"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationViewerBody = exports.InstructorNotificationViewer = exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _base = require("modals/base");

var _decorators = require("decorators");

var _List = babelHelpers.interopRequireDefault(require("./List"));

var _Listener = babelHelpers.interopRequireDefault(require("components/Notifications/Listener"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _class, _temp, _class3, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _class4, _temp2, _class5, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _temp3, _class7, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _temp4;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var NotificationViewer =
/*#__PURE__*/
function (_ReactModal) {
  babelHelpers.inherits(NotificationViewer, _ReactModal);

  function NotificationViewer() {
    var _this;

    var twoPane = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var tabs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    babelHelpers.classCallCheck(this, NotificationViewer);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(NotificationViewer).call(this));
    _this.removeOnHide = true;
    _this.hasModalTitleElement = false;
    _this.classList = _this.classList.concat('notification-viewer-modal');
    _this.twoPane = twoPane;
    _this.tabs = tabs;

    _this.setComponent(_this.makeComponent({
      notificationList: null
    }));

    return _this;
  }

  babelHelpers.createClass(NotificationViewer, [{
    key: "makeComponent",
    value: function makeComponent() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _react.default.createElement(NotificationViewerBody, _extends({
        twoPane: this.twoPane,
        tabs: this.tabs
      }, props));
    }
  }, {
    key: "setNotifications",
    value: function setNotifications(value, selectedItem) {
      this.setComponent(this.makeComponent({
        notificationList: value,
        selectedItem: selectedItem
      }));
      this.notificationList = value;
      this.selectedItem = selectedItem;
    }
  }, {
    key: "show",
    value: function show() {
      var _this2 = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _promisePolyfill.default.resolve(true).then(function () {
        var _babelHelpers$get;

        var item = _this2.notificationList.feed.filter(function (item) {
          return item.id == _this2.selectedItem;
        })[0];

        var helper = require('components/Notifications/viewer.' + item.openInline).viewer;

        if (helper) {
          helper(_this2.notificationList, _this2.selectedItem, item);
          return null;
        }

        return (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(NotificationViewer.prototype), "show", _this2)).call.apply(_babelHelpers$get, [_this2].concat(args));
      });
    }
  }]);
  return NotificationViewer;
}(_base.ReactModal);

exports.default = NotificationViewer;
var InstructorNotificationViewer = (_class = (_temp =
/*#__PURE__*/
function (_NotificationViewer) {
  babelHelpers.inherits(InstructorNotificationViewer, _NotificationViewer);
  babelHelpers.createClass(InstructorNotificationViewer, [{
    key: "makeComponent",
    value: function makeComponent(props) {
      var loading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this._currentProps = props;
      return _react.default.createElement(NotificationViewerBody, _extends({
        loading: loading,
        twoPane: this.twoPane,
        feed: props.notificationList,
        selectTab: this.selectTab,
        tabs: this.tabs,
        canSelectTab: this.canSelectTab
      }, props));
    }
  }, {
    key: "selectTab",
    value: function selectTab(tab, withItem) {
      var _this4 = this;

      this.setComponent(this.makeComponent(this._currentProps, true));
      this.fetchFeed(this.source, tab.baseFilter).then(function (feed) {
        _this4.setNotifications(feed, withItem || _this4.selectedItem || feed.feed[0].id);
      });
    }
  }, {
    key: "canSelectTab",
    value: function canSelectTab(tab) {
      var idx = this.tabs.indexOf(tab);
      return this.tabData[idx].count > 0;
    }
  }, {
    key: "icon",
    get: function get() {
      return "<span class='system-icon ".concat(this.iconName, "'></span>");
    }
  }, {
    key: "title",
    get: function get() {
      return this.viewerTitle;
    }
  }]);

  function InstructorNotificationViewer(source, title, icon) {
    var _this3;

    babelHelpers.classCallCheck(this, InstructorNotificationViewer);
    var tabs = [];
    var types = [];
    var feed = source;

    if (source == 'data/notifications/feeds/events') {
      types = ['eventTimeSuggested', 'eventStartingSoon'];
      tabs = [{
        title: 'Inbox',
        baseFilter: ['eventSubmitted', 'eventTimeAccepted', 'eventTimeComment', 'eventTimeRejected', 'eventTimeSuggested']
      }, {
        title: 'Upcoming',
        baseFilter: ['eventStartingSoon']
      }, {
        title: 'Past',
        baseFilter: ['eventFinished']
      }];
    }

    if (source == 'data/notifications/feeds/questions') {
      types = ['questionCreated', 'questionAnswered'];
      tabs = [{
        title: 'Inbox',
        baseFilter: ['questionCreated']
      }, {
        title: 'Past',
        baseFilter: ['questionAnswered']
      }];
    }

    if (source == 'data/notifications/feeds/applications') {
      types = ['applicationSubmitted'];
      tabs = [{
        title: 'Inbox',
        baseFilter: ['applicationSubmitted']
      }, {
        title: 'Past',
        baseFilter: ['applicationAccepted', 'applicationRejected']
      }];
    }

    if (source == 'data/notifications/feeds/assignments') {
      types = ['documentSubmitted', 'documentReply', 'videoSubmitted', 'videoReply'];
      tabs = [{
        title: 'Inbox',
        baseFilter: ['documentSubmitted', 'documentReply', 'videoSubmitted', 'videoReply']
      }, {
        title: 'Past',
        baseFilter: ['documentFinished', 'videoFinished']
      }];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(InstructorNotificationViewer).call(this, true, tabs));
    _this3.classList = _this3.classList.concat('notification-two-pane');
    _this3.hasModalTitleElement = true;
    _this3.types = [];
    _this3.source = source;
    _this3.types = types;
    _this3.iconName = icon;
    _this3.viewerTitle = title;
    return _this3;
  }

  babelHelpers.createClass(InstructorNotificationViewer, [{
    key: "show",
    value: function show() {
      var _this5 = this;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return (0, _fetch.default)("".concat(this.source, "?limit=0")).then(function (value) {
        return value.json();
      }).then(function (value) {
        return _this5.tabs.map(function (_ref) {
          var title = _ref.title,
              baseFilter = _ref.baseFilter;
          return {
            title: title,
            baseFilter: baseFilter,
            count: value.items.filter(function (item) {
              return baseFilter.indexOf(item.child_type) != -1;
            }).length
          };
        });
      }).then(function (tabs) {
        _this5.tabData = tabs;
        var selectedTab = tabs.filter(function (tab) {
          return tab.count > 0;
        })[0];
        return _this5.fetchFeed(_this5.source, selectedTab.baseFilter);
      }).then(function (feed) {
        _this5.setNotifications(feed, feed.feed[0].id);
      }).then(function () {
        var _babelHelpers$get2;

        return (_babelHelpers$get2 = babelHelpers.get(babelHelpers.getPrototypeOf(InstructorNotificationViewer.prototype), "show", _this5)).call.apply(_babelHelpers$get2, [_this5].concat(args));
      });
    }
  }, {
    key: "fetchFeed",
    value: function fetchFeed(source, filter) {
      var n = encodeURIComponent('filter[]');
      var p = filter.map(function (f) {
        return "".concat(n, "=").concat(encodeURIComponent(f));
      }).join('&');
      return (0, _fetch.default)("".concat(source, "?").concat(p)).then(function (value) {
        return value.json();
      });
    }
  }]);
  return InstructorNotificationViewer;
}(NotificationViewer), _temp), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "selectTab", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "selectTab"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "canSelectTab", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "canSelectTab"), _class.prototype)), _class);
exports.InstructorNotificationViewer = InstructorNotificationViewer;
var TabbedNotificationList = (_class3 = (_temp2 = _class4 =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(TabbedNotificationList, _Component);

  function TabbedNotificationList() {
    var _babelHelpers$getProt;

    var _this6;

    babelHelpers.classCallCheck(this, TabbedNotificationList);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this6 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(TabbedNotificationList)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this6, "tabs", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "initialSelected", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "notifications", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "onSelected", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "open", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "loading", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "canSelectTab", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "selectTab", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    _this6.state = {
      selectedTab: null,
      tabNotifications: [],
      itemsShown: TabbedNotificationList.itemsPerPage
    };
    return _this6;
  }

  babelHelpers.createClass(TabbedNotificationList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentDidUpdate();
    }
  }, {
    key: "_shallowCompare",
    value: function _shallowCompare(a, b) {
      var ignored = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var k = Object.keys(a).concat(Object.keys(b));
      k = k.filter(function (k) {
        return ignored.indexOf(k) == -1;
      });

      for (var i = 0; i < k.length; i++) {
        if (a[k[i]] !== b[k[i]]) return false;
      }

      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this7 = this;

      if (prevProps && this._shallowCompare(prevProps, this.props, ['loading'])) {
        if (prevState && prevState.selectedTab != this.state.selectedTab) {
          var item = this.state.tabNotifications[this.state.selectedTab].feed.filter(function (item) {
            return item.id == _this7.initialSelected;
          })[0];
          if (!item) item = this.state.tabNotifications[this.state.selectedTab].feed[0];
          if (item) this.onSelected(item);else this.setState({
            forceUpdate: true
          });
        }

        return;
      }

      this.setState(function (_ref2) {
        var selectedTab = _ref2.selectedTab;
        var r = {
          tabNotifications: _this7.getTabbedNotificationContent()
        };

        if (!prevProps || prevProps.initialSelected != _this7.props.initialSelected) {
          for (var i = 0; i < r.tabNotifications.length; i++) {
            var x = r.tabNotifications[i].feed.filter(function (item) {
              return item.id == _this7.initialSelected;
            });

            if (x.length) {
              var pos = r.tabNotifications[i].feed.indexOf(x[0]);
              r.itemsShown = Math.max(TabbedNotificationList.itemsPerPage, TabbedNotificationList.itemsPerPage * Math.ceil((1 + pos) / TabbedNotificationList.itemsPerPage));
              r.selectedTab = selectedTab = i;
              r.currentTab = Object.assign({}, r.tabNotifications[i]);
              r.currentTab.feed = r.currentTab.feed.slice(0, r.itemsShown);
              if (prevProps && _this7.props.notifications !== prevProps.notifications) r.forceUpdate = false;
              return r;
            }
          }
        }

        if (null === selectedTab || _this7.state.forceUpdate) {
          for (var i = 0; i < r.tabNotifications.length; i++) {
            if (r.tabNotifications[i].feed.length > 0) {
              r.selectedTab = i;
              r.itemsShown = TabbedNotificationList.itemsPerPage;
              r.currentTab = Object.assign({}, r.tabNotifications[r.selectedTab]);
              r.currentTab.feed = r.currentTab.feed.slice(0, r.itemsShown);
              if (prevProps && _this7.props.notifications !== prevProps.notifications) r.forceUpdate = false;
              return r;
            }
          }

          r.selectedTab = 0;
          r.itemsShown = TabbedNotificationList.itemsPerPage;
          r.currentTab = Object.assign({}, r.tabNotifications[r.selectedTab]);
          r.currentTab.feed = r.currentTab.feed.slice(0, r.itemsShown);
          if (prevProps && _this7.props.notifications !== prevProps.notifications) r.forceUpdate = false;
        }

        return r;
      });
    }
  }, {
    key: "hasMore",
    value: function hasMore() {
      return this.state.tabNotifications[this.state.selectedTab].feed.length > this.state.itemsShown;
    }
  }, {
    key: "more",
    value: function more() {
      this.setState(function (state) {
        var itemsShown = state.itemsShown,
            tabNotifications = state.tabNotifications,
            selectedTab = state.selectedTab;
        var r = {
          itemsShown: itemsShown + TabbedNotificationList.itemsPerPage
        };
        r.currentTab = Object.assign({}, tabNotifications[selectedTab]);
        r.currentTab.feed = r.currentTab.feed.slice(0, r.itemsShown);
        return r;
      });
    }
  }, {
    key: "getTabbedNotificationContent",
    value: function getTabbedNotificationContent() {
      var _this8 = this;

      var tn = [];

      for (var i = 0; i < this.tabs.length; i++) {
        tn.push({
          account: this.notifications.account,
          err: [],
          feed: [],
          items: [],
          newCount: 0,
          timeStamp: this.notifications.timeStamp
        });
      }

      this.notifications.feed.forEach(function (notification) {
        for (var i = 0; i < _this8.tabs.length; i++) {
          if (_this8.tabs[i].baseFilter.indexOf(notification.type) != -1) {
            tn[i].feed.push(notification);
            if (notification.isNew) tn[i].newCount++;
            return;
          }
        }
      });
      return tn;
    }
  }, {
    key: "doSelectTab",
    value: function doSelectTab(_ref3) {
      var _ref3$target = _ref3.target,
          className = _ref3$target.className,
          tabIndex = _ref3$target.dataset.tabIndex;
      if (className == 'disabled') return;
      var index = Number(tabIndex);
      this.setState({
        selectedTab: index
      });
      this.selectTab(this.tabs[Number(tabIndex)]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      if (!this.tabs.length) {
        return _react.default.createElement(_List.default, {
          initialSelected: this.initialSelected,
          notifications: this.notifications,
          onSelected: this.onSelected,
          open: this.open
        });
      }

      if (this.state.selectedTab === null) return null;
      return _react.default.createElement("div", {
        className: "tabbed-notification-viewer"
      }, _react.default.createElement("div", {
        className: "tabs"
      }, _react.default.createElement("ul", {
        className: "nav nav-tabs"
      }, this.tabs.map(function (tab, index) {
        return _react.default.createElement("li", {
          className: _this9.state.selectedTab == index ? 'active' : void 0
        }, _react.default.createElement("a", {
          href: "javascript:void(0)",
          className: _this9.canSelectTab(tab) ? '' : 'disabled',
          onClick: _this9.doSelectTab,
          "data-tab-index": index
        }, tab.title));
      }))), _react.default.createElement("div", {
        className: "tabbed-notifications"
      }, _react.default.createElement(_List.default, {
        initialSelected: this.initialSelected,
        notifications: this.state.currentTab,
        hasMore: this.hasMore(),
        showMore: this.more,
        onSelected: this.onSelected,
        open: this.open
      }), this.loading && _react.default.createElement("div", {
        className: "notification-list open",
        style: {
          background: 'rgb(85%, 85%, 85%)'
        }
      }, _react.default.createElement("div", {
        style: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '20%',
          height: '20%',
          transform: 'translate(-50%, -50%)'
        },
        "data-spin": "true",
        className: "spinning"
      }))));
    }
  }]);
  return TabbedNotificationList;
}(_react.Component), _class4.itemsPerPage = 20, _temp2), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "tabs", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "initialSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "notifications", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "onSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "open", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "loading", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "canSelectTab", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this10 = this;

    return function (tab) {
      var index = _this10.tabs.indexOf(tab);

      return _this10.state.tabNotifications[index].feed.length > 0;
    };
  }
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "selectTab", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (tab) {};
  }
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "more", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "more"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "doSelectTab", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "doSelectTab"), _class3.prototype)), _class3);
var NotificationViewerBody = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(NotificationViewerBody, _Component2);

  function NotificationViewerBody() {
    var _babelHelpers$getProt2;

    var _this11;

    babelHelpers.classCallCheck(this, NotificationViewerBody);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this11 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(NotificationViewerBody)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this11, "notificationList", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    babelHelpers.initializerDefineProperty(_this11, "selectedItem", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    babelHelpers.initializerDefineProperty(_this11, "twoPane", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    babelHelpers.initializerDefineProperty(_this11, "tabs", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    babelHelpers.initializerDefineProperty(_this11, "types", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    babelHelpers.initializerDefineProperty(_this11, "filter", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    babelHelpers.initializerDefineProperty(_this11, "feed", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this11)));
    _this11.state = {
      selectedItem: _this11.selectedItem,
      notificationList: _this11.notificationList
    };
    _this11.state.cloneNotificationList = _this11.getCloneList(_this11.notificationList, _this11.selectedItem);
    return _this11;
  }

  babelHelpers.createClass(NotificationViewerBody, [{
    key: "getCloneList",
    value: function getCloneList(list, selected) {
      return {
        account: list.account,
        items: list.items.filter(function (item) {
          return item.id == selected;
        }),
        feed: list.feed.filter(function (item) {
          return item.id == selected;
        }),
        err: [],
        newCount: 0,
        timeStamp: list.timeStamp
      };
    }
  }, {
    key: "selectNotificationById",
    value: function selectNotificationById(id) {
      var _this12 = this;

      if (this.state.notificationList.feed.filter(function (item) {
        return item.id == id;
      }).length) {
        this.setState(function (state) {
          return {
            selectedItem: id,
            cloneNotificationList: _this12.getCloneList(state.notificationList, id)
          };
        });
      } else {
        var item = this.state.notificationList.items.filter(function (item) {
          return item.id == id;
        })[0];

        if (item) {
          for (var i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].baseFilter.indexOf(item.child_type) != -1) {
              this.props.selectTab(this.tabs[i], item.id);
              return true;
            }
          }
        }
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: this.twoPane ? 'notification-viewer two-pane' : 'notification-viewer'
      }, this.twoPane && _react.default.createElement(TabbedNotificationList, _extends({}, this.props, {
        initialSelected: this.state.selectedItem,
        notifications: this.state.notificationList,
        onSelected: this.selectNotification,
        open: true
      })), _react.default.createElement("div", {
        className: "notification-body"
      }, _react.default.createElement(NotificationBody, {
        selectedItem: this.state.selectedItem,
        notifications: this.state.cloneNotificationList,
        selectNotificationById: this.selectNotificationById,
        allNotifications: this.notificationList
      })));
    }
  }, {
    key: "selectNotification",
    value: function selectNotification(item) {
      var _this13 = this;

      this.setState(function (state) {
        return {
          selectedItem: item.id,
          cloneNotificationList: _this13.getCloneList(state.notificationList, item.id)
        };
      });
      return true;
    }
  }, {
    key: "notificationListChanged",
    value: function notificationListChanged() {
      var _this14 = this;

      if (this._timer) return;
      this._timer = setTimeout(function () {
        (0, _fetch.default)(_this14.feed).then(function (v) {
          return v.json();
        }).then(function (v) {
          if (_this14.filter) v = Object.assign(v, {
            feed: v.feed.filter(_this14.filter)
          });

          _this14.setState({
            notificationList: v
          });

          _this14._timer = null;
        });
      }, 250);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this15 = this;

      if (this.types) {
        this.types.forEach(function (type) {
          _Listener.default.addEventListener(type, _this15.notificationListChanged);

          _Listener.default.addEventListener("updated-".concat(type), _this15.notificationListChanged);

          _Listener.default.addEventListener("removed-".concat(type), _this15.notificationListChanged);
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this16 = this;

      if (this.types !== prevProps.types) {
        if (prevProps.types) {
          prevProps.types.forEach(function (type) {
            _Listener.default.removeEventListener(type, _this16.notificationListChanged);

            _Listener.default.removeEventListener("updated-".concat(type), _this16.notificationListChanged);

            _Listener.default.removeEventListener("removed-".concat(type), _this16.notificationListChanged);
          });
        }

        if (this.types) {
          this.types.forEach(function (type) {
            _Listener.default.addEventListener(type, _this16.notificationListChanged);

            _Listener.default.addEventListener("updated-".concat(type), _this16.notificationListChanged);

            _Listener.default.addEventListener("removed-".concat(type), _this16.notificationListChanged);
          });
        }
      }

      if (this.props.notificationList !== prevProps.notificationList) {
        this.setState(babelHelpers.objectSpread({
          notificationList: this.props.notificationList,
          cloneNotificationList: this.getCloneList(this.props.notificationList, this.selectedItem)
        }, this.props.selectedItem != prevProps.selectedItem ? {
          selectedItem: this.props.selectedItem
        } : {}));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this17 = this;

      if (this.types) {
        this.types.forEach(function (type) {
          _Listener.default.removeEventListener(type, _this17.notificationListChanged);

          _Listener.default.removeEventListener("updated-".concat(type), _this17.notificationListChanged);

          _Listener.default.removeEventListener("removed-".concat(type), _this17.notificationListChanged);
        });
      }
    }
  }]);
  return NotificationViewerBody;
}(_react.Component), _temp3), (_descriptor9 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "notificationList", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "selectedItem", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "twoPane", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "tabs", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "selectNotificationById", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "selectNotificationById"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "selectNotification", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "selectNotification"), _class5.prototype), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "types", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor14 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "filter", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "feed", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "notificationListChanged", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "notificationListChanged"), _class5.prototype)), _class5);
exports.NotificationViewerBody = NotificationViewerBody;
var NotificationBody = (_class7 = (_temp4 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(NotificationBody, _Component3);

  function NotificationBody() {
    var _babelHelpers$getProt3;

    var _this18;

    babelHelpers.classCallCheck(this, NotificationBody);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this18 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(NotificationBody)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this18, "selectedItem", _descriptor16, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this18)));
    babelHelpers.initializerDefineProperty(_this18, "notifications", _descriptor17, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this18)));
    babelHelpers.initializerDefineProperty(_this18, "selectNotificationById", _descriptor18, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this18)));
    babelHelpers.initializerDefineProperty(_this18, "allNotifications", _descriptor19, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this18)));
    return _this18;
  }

  babelHelpers.createClass(NotificationBody, [{
    key: "theItem",
    value: function theItem() {
      var _this19 = this;

      if (this.selectedItem) {
        return this.notifications.feed.filter(function (item) {
          return item.id == _this19.selectedItem;
        })[0];
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var item = this.theItem();

      if (item) {
        try {
          var Target = require('components/Notifications/viewer.' + item.openInline).default;

          return _react.default.createElement("div", {
            className: "notification-body-content"
          }, _react.default.createElement(Target, {
            item: item,
            selectNotificationById: this.selectNotificationById,
            allNotifications: this.allNotifications
          }));
        } catch (e) {
          ;
        }
      }

      return _react.default.createElement("div", {
        className: "notification-body-content"
      });
    }
  }]);
  return NotificationBody;
}(_react.Component), _temp4), (_descriptor16 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "selectedItem", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "notifications", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "selectNotificationById", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "allNotifications", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class7);